import React from 'react'
import { FilesModel } from './filesModel'
import { FormattedMessage } from 'react-intl'
import Button from '../../../components/button/Button'
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'
import { saveInteractions } from '../../gtm/utils/gtmCallback'
import portals from '../../../enums/portalsEnum'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			fileContainerStyle: {
				position: 'relative',

				'& .bloc-container': {
					background: theme.palette.blue.main,
					color: 'white',
					height: '100%',
					minHeight: 100,

					'& div': {
						width: '55%',
						height: '95%'
					}
				}
			},
			fileContainerLargeScreenStyle: {
				paddingTop: 30,
				marginTop: 37,
				minHeight: 250,
				width: '47%',

				'& .bloc-container': {
					marginRight: 40,
					padding: '14px 0 20px 41px',

					'& button': {
						width: 150
					}
				},
				'&:first-child': {
					marginRight: 40
				}
			},
			fileContainerSmallScreenStyle: {
				paddingTop: 13.5,
				minHeight: 150,
				width: '100%',

				'& .bloc-container': {
					marginRight: 13.5,
					padding: '13px 0 24px 16px',

					'& button': {
						width: 109
					}
				},
				'&:first-child': {
					marginTop: 56
				},
				'&:not(:first-child)': {
					marginTop: 16.5
				}
			},
			imageStyle: {
				position: 'absolute',
				top: 0,
				right: 0,
			},
			imageLargeScreenStyle: {
				width: '40%'
			},
			imageSmallScreenStyle: {
				height: '80%'
			}
		}
	)
)

interface AcceptingProps {
	file: FilesModel
}

type FileCardProps = AcceptingProps

const FileCard: React.FC<FileCardProps> = (
	{
		file
	}
) => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const fileContainerClass: ClassValue = classNames(
		classes.fileContainerStyle,
		isLargeScreen ? classes.fileContainerLargeScreenStyle : classes.fileContainerSmallScreenStyle
	)

	const detailsContainerClass: ClassValue = classNames(
		classes.flex,
		classes.flexColumn,
		classes.flexBetween
	)

	const titleClass: ClassValue = classNames(
		classes.colorWhite,
		isLargeScreen ? classes.title3 : classes.title7
	)

	const imageClass: ClassValue = classNames(
		classes.imageStyle,
		isLargeScreen ? classes.imageLargeScreenStyle : classes.imageSmallScreenStyle
	)

	const downloadFile = () => {
		saveInteractions(
			{
				category: 'Vos Demandes',
				action: 'Téléchargement de documents',
				label: file.name
			}
		)

		const a = document.createElement('a')
		a.href = file.url
		a.target = '_blank'
		if (process.env.REACT_APP_TARGET === portals.campus) {
			a.download = file.name
		}
		a.click()
	}

	return (
		<div className={fileContainerClass}>
			<div className="bloc-container">
				<div className={detailsContainerClass}>
					<h1 className={titleClass}>
						<FormattedMessage
							id={file.translation}
							defaultMessage="Votre guide des réparations locatives"
							description="Title of the file"
						/>
					</h1>

					<Button
						background="backgroundDynamicGreenToWhite"
						color="colorTextAccessibility"
						textStyle={isLargeScreen ? 'text4' : 'text14'}
						onClick={downloadFile}
						size={isLargeScreen ? 'mediumButton' : 'smallButton'}
					>
						{ process.env.REACT_APP_TARGET === portals.campus ?
							<>
								<VerticalAlignBottomIcon />
								<FormattedMessage
									id="requests.download"
									defaultMessage="Télécharger"
									description="Download button"
								/>
							</>
							:
							<FormattedMessage
								id="requests.visit"
								defaultMessage="Consulter"
								description="Visit button"
							/>
						}
					</Button>
				</div>
			</div>
			<img
				src={file.img}
				alt={file.name}
				className={imageClass}
			/>
		</div>
	)
}

export default FileCard
